export default function PricingSection() {
  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-purple-950/20 to-black">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            料金について
          </h2>
          <p className="text-xl text-gray-300">
            明確な料金体系で安心してご注文いただけます
          </p>
        </div>

        <div className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl p-8 md:p-12 border border-purple-500/20">
          <div className="space-y-8">

            {/* 商品価格 */}
            <div className="pb-8 border-b border-purple-500/20">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
                <i className="ri-price-tag-3-line text-yellow-400"></i>
                商品価格
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white/5 rounded-2xl p-5 border border-purple-500/20 flex flex-col items-center text-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-goblet-line text-xl text-black"></i>
                  </div>
                  <p className="text-white font-semibold text-base">通常オリシャン</p>
                  <p className="text-yellow-400 font-bold text-2xl">2,750<span className="text-sm font-normal text-gray-300 ml-1">円 / 1本</span></p>
                </div>
                <div className="bg-white/5 rounded-2xl p-5 border border-purple-500/20 flex flex-col items-center text-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-flashlight-line text-xl text-black"></i>
                  </div>
                  <p className="text-white font-semibold text-base">LED付きオリシャン</p>
                  <p className="text-yellow-400 font-bold text-2xl">3,080<span className="text-sm font-normal text-gray-300 ml-1">円 / 1本</span></p>
                </div>
                <div className="bg-white/5 rounded-2xl p-5 border border-purple-500/20 flex flex-col items-center text-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-key-2-line text-xl text-black"></i>
                  </div>
                  <p className="text-white font-semibold text-base">アクリルキーホルダー</p>
                  <p className="text-yellow-400 font-bold text-2xl">198<span className="text-sm font-normal text-gray-300 ml-1">円〜</span></p>
                </div>
              </div>
            </div>

            <div className="flex items-start gap-4 pb-6 border-b border-purple-500/20">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-cart-line text-xl text-black"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-2">最小注文数</h3>
                <p className="text-2xl text-yellow-400 font-bold">6本から</p>
              </div>
            </div>

            <div className="flex items-start gap-4 pb-6 border-b border-purple-500/20">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-xl text-black"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-2">納期</h3>
                <p className="text-2xl text-yellow-400 font-bold">お支払い確認後、営業日5日以内に発送</p>
              </div>
            </div>

            <div className="flex items-start gap-4 pb-6 border-b border-purple-500/20">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-bank-card-line text-xl text-black"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-2">支払い方法</h3>
                <p className="text-2xl text-yellow-400 font-bold">銀行振込</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-price-tag-3-line text-xl text-black"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-3">送料</h3>
                <p className="text-gray-300 mb-4">注文本数、場所により料金が異なります。</p>
                <p className="text-gray-300">詳しい料金については、LINEにてお気軽にお問い合わせください。</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-lg font-bold px-10 py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-2xl"></i>
            料金について詳しく聞く
          </a>
        </div>
      </div>
    </section>
  );
}